import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const TimeWarpAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const p = progress < 0.5 ? progress * 2 : 2 - progress * 2;
  for(let i=0; i<32; i++){
    const ang = (i/32)*Math.PI*2;
    const rStart = getRadiusAtAngle(ang, e, e.maxRadius);
    const rEnd = getRadiusAtAngle(ang, e, e.maxRadius + 150 * p);
    ctx.beginPath(); ctx.moveTo(e.pos.x + Math.cos(ang) * rStart, e.pos.y + Math.sin(ang) * rStart);
    ctx.lineTo(e.pos.x + Math.cos(ang)*rEnd, e.pos.y + Math.sin(ang)*rEnd);
    ctx.lineWidth = 3; ctx.stroke();
  }
};

registerBlastAnimation('TIME_WARP', TimeWarpAnimation);
